import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataSubFilter
} from '../components/odata-filter/models/odata-filter';
import { FilterOperator, OPERATORS } from '../components/odata-filter/models/operators';
import { SearchValueType } from '../components/odata-filter/models/search-value-type';
import { ODataFilterBuilder } from './odata-filter-builder';

export class RegularFilterModel implements ODataFilter {
  childFieldName = '';
  targetFieldId = '';
  filterGroup = FilterGroup.SystemFields;
  subFilter = new ODataSubFilter();
  constructor(
    public displayName: string,
    public targetField: string,
    public valueType: SearchValueType,
    public values?: any[],
    public unaccent: boolean = false
  ) {}
  buildFilter(
    searchValue: any,
    filterOperator: FilterOperator,
    subQueryFilters?: any[],
    buildForAutomation?: boolean
  ) {
    let operatorTypes = OPERATORS[this.valueType];

    if (
      operatorTypes.operators.findIndex(
        (x) => x.displayOperator == filterOperator.displayOperator
      ) == -1
    ) {
      throw new Error('Invalid Operation');
    }

    if (this.valueType == SearchValueType.Date) {
      return this.getDateFilter(searchValue, filterOperator, buildForAutomation);
    } else {
      return this.getOtherTypeOfFilter(searchValue, filterOperator);
    }
  }
  private getOtherTypeOfFilter(searchValue: any, filterOperator: FilterOperator) {
    let filter: { [k: string]: any } = {};
    if (
      this.valueType == SearchValueType.String ||
      this.valueType == SearchValueType.Email ||
      this.valueType == SearchValueType.EmptyOperator ||
      this.valueType == SearchValueType.PhoneNumber
    ) {
      let _searchValue =
        filterOperator.displayOperator == FilterOperatorType.isEmpty ||
        filterOperator.displayOperator == FilterOperatorType.isNotEmpty
          ? null
          : searchValue;
      if (
        this.valueType == SearchValueType.String ||
        this.valueType == SearchValueType.EmptyOperator
      ) {
        filter = ODataFilterBuilder.buildStringFilter(
          this.targetField,
          _searchValue,
          filterOperator.actualOperator,
          false,
          this.unaccent
        );
      }
      if (this.valueType == SearchValueType.Email) {
        filter = ODataFilterBuilder.buildEmailFilter(
          this.targetField,
          _searchValue,
          filterOperator.actualOperator
        );
      } else if (this.valueType == SearchValueType.PhoneNumber) {
        filter = ODataFilterBuilder.buildPhoneNumberFilter(
          this.targetField,
          _searchValue,
          filterOperator.actualOperator
        );
      }
    } else if (this.valueType == SearchValueType.Number) {
      let _searchValue =
        filterOperator.displayOperator == FilterOperatorType.isEmpty ||
        filterOperator.displayOperator == FilterOperatorType.isNotEmpty
          ? 0
          : searchValue;

      filter = ODataFilterBuilder.buildNumberFilter(
        this.targetField,
        _searchValue,
        filterOperator.actualOperator
      );
    } else if (this.valueType == SearchValueType.MultiValue) {
      let _searchValue =
        searchValue && searchValue.length ? searchValue.map((x) => x.searchValue) : [];
      let _opt =
        filterOperator.displayOperator == FilterOperatorType.notIn
          ? FilterOperatorType.in
          : filterOperator.displayOperator;

      filter = ODataFilterBuilder.buildArrayFilter(this.targetField, _searchValue, _opt);
    } else if (
      this.valueType == SearchValueType.Boolean ||
      this.valueType == SearchValueType.List
    ) {
      filter = ODataFilterBuilder.buildSimpleFilter(
        this.targetField,
        searchValue,
        filterOperator.actualOperator
      );
    } else if (this.valueType == SearchValueType.Guid) {
      filter = ODataFilterBuilder.buildGuidFilter(
        this.targetField,
        searchValue,
        filterOperator.actualOperator
      );
    }
    if (
      filterOperator.displayOperator == FilterOperatorType.notContains ||
      filterOperator.displayOperator == FilterOperatorType.notIn
    )
      return { not: filter };
    return filter;
  }

  private getDateFilter(
    searchValue: any,
    filterOperator: FilterOperator,
    buildForAutomation: boolean
  ) {
    return ODataFilterBuilder.buildDateFilter(
      this.targetField,
      searchValue,
      filterOperator.displayOperator,
      false,
      buildForAutomation
    );
  }
}
